var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeskalasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1172_1199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5909 41H2.91386C1.3046 41 0 39.7011 0 38.099V2.901C0 1.29884 1.3046 0 2.91386 0H20.5909C31.9629 0 41.1817 9.17817 41.1817 20.5V20.5C41.1817 31.8218 31.9629 41 20.5909 41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9253 8.45312V14.582C22.9253 17.9669 20.1692 20.7109 16.7693 20.7109H10.6133C10.6133 13.9411 16.1256 8.45312 22.9253 8.45312Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6133 20.2891H16.7693C20.1692 20.2891 22.9253 23.033 22.9253 26.4179V32.5468C16.1256 32.5468 10.6133 27.0588 10.6133 20.2891Z",
    fill: "#FDFDFD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1172_1199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskalasIcon);
export default __webpack_public_path__ + "static/media/deskalasIcon.85efd32c74eb4c353ab766e980c42c87.svg";
export { ForwardRef as ReactComponent };